
import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component
export default class UiAnimationDropdownComponent extends Vue {
  @Model('onSelected', {type: String, default: null}) value: string;
  innerValue: string = null;
  animations: AnimationResponse[] = [];
  isLoading = false;
  isLoaded = false;
  noAnimation: AnimationResponse = {
    Id: null,
    Name: 'не выбрано',
    Url: null
  };
  get dropdownItems(): AnimationResponse[] {
    const items = [this.noAnimation, ...this.animations];
    if (this.innerValue && !items.some((item) => item.Id === this.innerValue)) {
      items.push({
        Id: this.innerValue,
        Name: "текущая анимация",
        Url: null,
      });
    }
    return items;
  }
  @Watch('value')
  onValueChanged() {
    this.innerValue = this.value;
  }
  @Watch('innerValue')
  onInnerValueChanged() {
    this.$emit('onSelected', this.innerValue);
    this.$emit('onAnimationChoose', this.animations.find(x=>x.Id == this.innerValue));  
  }
  async created() {
    this.innerValue = this.value;
  }
  async loadAnimations() {
    if (this.isLoading || this.isLoaded) {
      return;
    }
    this.isLoading = true;
    try {
      const res = await this.$api.AnimationService.getAnimationsAsync();
      this.animations = res || [];
      this.isLoaded = true;
    } catch (error) {
      this.animations = [];
      const errorMessage = ((error || {}).ErrorMessage || '').toString();
      const isMissingHttpRoute = errorMessage.indexOf('HTTP route is not configured') >= 0;
      if ((error || {}).StatusCode !== 401 && !isMissingHttpRoute) {
        this.$notification.error(error);
      }
    } finally {
      this.isLoading = false;
    }
  }
}
